import gql from 'graphql-tag';

const backgroundCheckStep = `
  id
  status
  supportingDocument {
    accessibleUrl
    createdAt
    type
    uri
  }
  type
`;

const backgroundCheck = `
  id, 
  taxIdentifier, 
  status,
  displayStatus,
  steps{
    ${backgroundCheckStep}
  }
`;

export const backgroundCheckGroup = `
    id, 
    referenceId, 
    backgroundChecks{
      ${backgroundCheck}
    }
`;

const serasaOccurrenceDetail = `
  occurrenceDate
  legalNatureId
  legalNature
  contractId
  creditorName
  amount
  federalUnit
  principal
`;

const serasaReport = `
	reports {
    dateReport,
    taxIdentifier
    status,
    occurrences {
      name
      count
      firstOccurrence
      lastOccurrence
      balance
      details {
        ${serasaOccurrenceDetail}
      }
    }
  }
`;

const bacenReport = `
  reports {
    status
    taxIdentifier
    dateReport
    financialLossValue
    fullResponsibilityValue
    overdueValue
    percentageOfDebts
    reasons
  }
`;

const contactsRiskClassification = `
  status
  classifications {
    contactTaxIdentifier
    riskClassificationLevel
    classificationDate
    isExpired
  }
`;

export const latestBackgroundCheck = gql`
  query latestBackgroundCheck($taxIdentifier: String!) {
    latestBackgroundCheck(taxIdentifier: $taxIdentifier) {
      ${backgroundCheck}
    }
  }
`;

export const setBackgroundCheckStepDecision = gql`
  mutation setBackgroundCheckStepDecision($stepId: ID!, $decision: DecisionBackgroundCheckStepStatus, $comment: String) {
    setBackgroundCheckStepDecision(stepId: $stepId, decision: $decision, comment: $comment) {
      ${backgroundCheckStep}
    }
  }
`;

export const retryBackgroundCheckStep = gql`
  mutation retryBackgroundCheckStep($stepId: ID!) {
    retryBackgroundCheckStep(stepId: $stepId) {
      ${backgroundCheckStep}
    }
  }
`;

export const getBackgroundCheckGroup = gql`
query getBackgroundCheckGroup($referenceId: String!){
  backgroundCheckGroup(referenceId: $referenceId){
    ${backgroundCheckGroup}
  }
}
`;

export const getOpportunityContactRolesAndBackgroundCheckGroup = gql`
  query getOpportunityContactRolesAndBackgroundCheckGroup($opportunityId: String!) {
    opportunityContactRoles(opportunityId: $opportunityId) {
      contact {
        name
        taxIdentifier
      }
      contactId
      id
      isPrimary
      role
    }
    backgroundCheckGroup(referenceId: $opportunityId){
      ${backgroundCheckGroup}
    }
    serasaReport(opportunityId: $opportunityId) {
      ${serasaReport}
    }
    bacenReport(opportunityId: $opportunityId) {
      ${bacenReport}
    }
    contactsRiskClassification(opportunityId: $opportunityId) {
      ${contactsRiskClassification}
    }
  }
`;

export const getSerasaReport = gql`
  query getSerasaReport($opportunityId: String!) {
    serasaReport(opportunityId: $opportunityId) {
      ${serasaReport}
    }
  }
`;

export const getContactsRiskClassification = gql`
  query contactsRiskClassification($opportunityId: String!) {
    contactsRiskClassification(opportunityId: $opportunityId) {
      ${contactsRiskClassification}
    }
  }
`;

export const getBackgroundCheckStepEvents = gql`
  query getBackgroundCheckStepEvents($stepId: String!, $limit: Int, $offset: Int) {
    backgroundCheckStepEvents(stepId: $stepId, limit: $limit, offset: $offset) {
      backgroundCheckStepEvents {
        id
        eventType
        comment
        createdAt
      }
      pageInfo {
        limit
        offset
        hasPreviousPage
        hasNextPage
      }
    }
  }
`;

export const addContactClassificationLevel = gql`
  mutation addContactClassificationLevel($data: ContactRiskClassificationInput!) {
    addContactClassificationLevel(data: $data) {
      contactTaxIdentifier
      riskClassificationLevel
      classificationDate
      isExpired
    }
  }
`;

export const getBacenReport = gql`
  query bacenReport($opportunityId: String!) {
    bacenReport(opportunityId: $opportunityId) {
      ${bacenReport}
    }
  }
`;
